/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Inject, Injectable } from '@angular/core';

import { PendoService as FleetmaticsPendoService } from '@fleetmatics/ui.insights';

import { IAppConfig } from '../../core/config/app-config.interfaces';
import { APP_CONFIG } from '../../core/config/app-config.token';
import { EApiErrorCodes } from '../models';

@Injectable({
  providedIn: 'root'
})
export class PendoService {
  pendoEnabled: boolean = this.appConfig.pendo.enabled;

  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: IAppConfig,
    private readonly fleetmaticsPendoService: FleetmaticsPendoService
  ) {}

  public trackEvent(eventName: string, properties: any): void {
    if (this.pendoEnabled) {
      this.fleetmaticsPendoService.trackEvent(eventName, properties);
    }
  }

  public trackErrorEvent(eventName: string, errorCode: number) {
    if (this.pendoEnabled) {
      const errorName = EApiErrorCodes[errorCode] ? ` | ${EApiErrorCodes[errorCode].replace(/([a-z])([A-Z])/g, '$1 $2')}` : '';
      this.fleetmaticsPendoService.trackEvent(`${eventName}${errorName}`, {
        errorCode
      });
    }
  }
}
